import PropTypes from "prop-types";
import React from "react";
import Button from "theme/components/atoms/Button";
import ButtonLink from "theme/components/atoms/Typography/Link/ButtonLink";

/** @param {ButtonItemProps["data"]["type"]} type */
const getButtonAppearance = (type) => {
  switch (type) {
    case "primary":
      return "primary";
    case "link":
      return "link";
    default:
      return "default";
  }
};

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} ButtonItemProps
 *
 * @type {React.FC<ButtonItemProps>}
 * @todo add support for widget links
 */
const ButtonItem = ({ data, ...props }) => {
  const buttonAppearance = getButtonAppearance(data.type);

  return (
    <span
      className="pb-button-item-wrapper"
      data-pb-style={data?.linkProps?.pbStyle ?? ""}
    >
      <ButtonLink
        buttonAppearance={buttonAppearance}
        to={data?.linkProps?.href || "#"}
        {...props}
      />
    </span>
  );
};

const propTypes = {
  data: PropTypes.shape({
    type: PropTypes.oneOf(["primary", "secondary", "link"]).isRequired,
    linkProps: PropTypes.shape({
      href: PropTypes.string.isRequired,
      target: PropTypes.string,
      type: PropTypes.oneOf(["default", "page", "category", "product"])
        .isRequired,
      pbStyle: PropTypes.string,
    }),
  }),
  className: PropTypes.string,
};

Button.propTypes = propTypes;

export default ButtonItem;
